import React, { useState } from 'react'
import { AToZContainerProps, LinkItem } from './types'
import InlineLink from '../Links/InlineLink'
import { LinkType } from '../Links/types'
import { letterOptions, linksForLetter } from './utils'
import InputToggleButton from '../InputToggleButton'
import { useTranslation } from 'react-i18next'
import './Scss/a-to-z-container.scss'

const AToZContainer = (props: AToZContainerProps) => {
    const { t } = useTranslation()
    const [selectedLetter, setSelectedLetter] = useState<string>('')
    const links = linksForLetter(props.allLinks, selectedLetter)
    const options = letterOptions(t('global.alphabet') || '')

    const onSelectLetter = (value: string) => {
        setSelectedLetter(value)
    }

    return (
        <div className={'a-to-z-container'}>
            <div className={'a-to-z-container__letter-selection'}>
                <InputToggleButton
                    id="atoz-letter-selector"
                    label={t('atoz.selectLetter')}
                    hideLabel={true}
                    options={options}
                    value={selectedLetter}
                    onSelect={onSelectLetter}
                    manyItems={true}
                />
            </div>
            <div className={'a-to-z-container__links'}>
                <h2>{selectedLetter}</h2>
                {links.map((link: LinkItem) => (
                    <div className={'link-item'} key={`${link.name}-${link.url}`}>
                        <InlineLink
                            text={link.name}
                            url={link.url}
                            type={LinkType.Intern}
                            hideIcon={true}
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default AToZContainer
